import { useMemo } from 'react'

import { getRecommendationsMetadataRegistryForPlatform } from '$extensionSrc/recommendations/recommendationRegistryApi'
import { RecommendationMetadataSpec } from '$extensionSrc/recommendations/recommendationTypes'
import { PLATFORM, RecommendationKey } from '$extensionSrc/utils/enums'

export type RecommendationMetadata = Partial<
  Record<RecommendationKey, RecommendationMetadataSpec>
>

export function getRecommendationMetadata(
  platform: PLATFORM | null | undefined,
): RecommendationMetadata | undefined {
  if (platform === undefined) {
    return undefined
  }
  if (platform === null) {
    return {}
  }
  return getRecommendationsMetadataRegistryForPlatform(platform)
}

export function useRecommendationMetadata(
  platform: PLATFORM | null | undefined,
): RecommendationMetadata | undefined {
  return useMemo(() => getRecommendationMetadata(platform), [platform])
}
